import { render, staticRenderFns } from "./ApplicantEvidence.vue?vue&type=template&id=1d13897f&scoped=true&"
import script from "./ApplicantEvidence.vue?vue&type=script&lang=js&"
export * from "./ApplicantEvidence.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantEvidence.vue?vue&type=style&index=0&id=1d13897f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d13897f",
  null
  
)

export default component.exports